import { Card, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Person from "../../images/Person.png";
const CustomCardForCovAppList = (props) => {
  return (
    <Card
      sx={{ borderRadius: "12px", padding: "8px" }}
      className="listCards"
      onClick={props.onClick}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <Box>
            <img
              src={Person}
              className="listIcons"
              sx={{ borderRadius: "40%", backgroundColor: "#E0F2F7" }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 700 }}>
              {props.applicantName} , {props.locality}
            </Typography>
            <Typography sx={{ fontWeight: 500 }}>
              {props.applicationNum}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>
            Date of Disbursement:
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "white",
              backgroundColor: "blue",
              padding: "6px",
              borderRadius: "12px",
            }}
          >
            {props.dateOfDisb}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>
            Disbursement Amount (₹):
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#1D6590",
            }}
          >
            {props.disbAmt.toLocaleString()}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>Preferred Language:</Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#1D6590",
            }}
          >
            English
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>File Status:</Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "blue",
            }}
          >
            {props.status}
          </Typography>
        </Box>
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
          padding: "8px",
        }}
      >
        <img src={props.imgSrc} className="listIcons" />
        <Box sx={{ display: "flex", gap: "18px" }}>
          <Typography sx={{ fontWeight: 700 }}>Application Number:</Typography>
          <Typography sx={{ fontWeight: 700 }}>23456787654</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "18px" }}>
          <Typography sx={{ fontWeight: 700 }}>Application Name:</Typography>
          <Typography sx={{ fontWeight: 700 }}>Naveen</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "18px" }}>
          <Typography sx={{ fontWeight: 700 }}>
            Date Of Disbursement:
          </Typography>
          <Typography sx={{ fontWeight: 700 }}>10/10/2023</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "18px" }}>
          <Typography sx={{ fontWeight: 700 }}>Disbursement Amount:</Typography>
          <Typography sx={{ fontWeight: 700 }}>230</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "18px" }}>
          <Typography sx={{ fontWeight: 700 }}>Status:</Typography>
          <Typography sx={{ fontWeight: 700 }}>Approved</Typography>
        </Box>
      </Box> */}
    </Card>
  );
};
export default CustomCardForCovAppList;
